import { SubstageInstanceStatus } from '@scale/shared-types';
import { ISensorFusionStageDefinitionLookupDto } from '@scale/sensor-fusion-shared';
import HideableSection from 'react-scale/corp/components/UI/HideableSection';

import GeneralPipelineNodeGraph from 'react-scale/corp/components/Lookup/sections/PipelineV3Graphs/GeneralPipelineNodeGraph';

type StageDefinitionPipelinePanelProps = {
  stageDefinition: ISensorFusionStageDefinitionLookupDto;
};

const StageDefinitionPipelinePanel = ({ stageDefinition }: StageDefinitionPipelinePanelProps) => {
  return (
    <div className="border border-solid border-neutral-200 px-4 py-4 flex flex-col gap-2">
      <HideableSection name="Stage Definition Pipeline">
        <GeneralPipelineNodeGraph
          nodes={stageDefinition.substageDefinitions.map(stage => ({
            ...stage,
            count: Object.values(SubstageInstanceStatus).reduce(
              (total, status) =>
                total + stage.statusCounts.unclaimed[status] + stage.statusCounts.claimed[status],
              0,
            ),
          }))}
        />
      </HideableSection>
    </div>
  );
};

export default StageDefinitionPipelinePanel;
